import dayjs, { Dayjs } from "dayjs";
import { Duration } from "dayjs/plugin/duration";
import _ from "lodash";

export type { Duration };

export function getDuration(dateA: Dayjs, dateB: Dayjs): Duration {
  const [minDate, maxDate] = dateA.isBefore(dateB) ? [dateA, dateB] : [dateB, dateA];
  const duration = dayjs.duration(maxDate.diff(minDate));
  return duration;
}

export function formatDurationYearsMonths(duration: Duration) {
  const years = duration.get("years");
  const months = duration.get("months");
  return [
    years > 0 && `${years} year${years > 1 ? "s" : ""}`,
    months > 0 && `${months} month${months > 1 ? "s" : ""}`,
  ]
    .filter(_.identity)
    .join(", ");
}

export function formatDurationDays(duration: Duration) {
  const durationInDays = duration.asDays();
  return `${_.round(durationInDays)} day${durationInDays === 1 ? "" : "s"}`;
}
